import { Injectable, Component, OnInit, Type } from '@angular/core';
import { Subject } from "rxjs/Subject";

export class ModalConfig {
  constructor(
    public component: Type<any>,
    public componentInputs: any = {},
  ) {}
}


@Injectable()
export class ModalService {

  component$: Subject<ModalConfig> = new Subject();

  constructor() {
  }

  showModal(input: ModalConfig) {
    this.component$.next(input);
  }

  closeModal() {
    this.component$.next(null);
  }
}



// WEBPACK FOOTER //
// /Users/jason/src/matrix/client/src/app/services/modal.ts